const ChartType = {
  LineDates: 'LineDates',
  LinePercentages: 'LinePercentages',
  BarPercentages: 'BarPercentages',
}

export default ChartType
